<e-list [(searchText)]="searchText" header="Apps" search>
  <ng-container slot="after-header">
    <button eBtn icon="plus" (click)="openCreateDialog()" color="primary" size="sm">Nieuw</button>
  </ng-container>
  <ng-container slot="header">
    <div style="width: 100%">
      <synchronize-app-navigation-items-button></synchronize-app-navigation-items-button>
    </div>
  </ng-container>

  <div (cdkDropListDropped)="onDrop($event)" cdkDropList class="fill-height">
    @for (app of filteredEgiApps; track app) {
      <e-collapsible-list-item
        (click)="select.emit(app)"
        [active]="activeAppId === app.id"
        [opened]="activeAppId === app.id"
        [title]="app.name"
        cdkDrag
        clickable
        actionsOnHover
        class="hover-highlight"
        >
        <ng-container slot="below-title">
          <div class="font-small">{{ app.info }} &nbsp;</div>
        </ng-container>
        @if (app.poolName) {
          <div class="d-flex justify-content-between mb-2">
            Pool
            <span>
              <e-badge color="elegant" prependIcon="map-marker-alt" small>{{ app.poolName }}</e-badge>
            </span>
          </div>
        }
        @if (app.machineName) {
          <div class="d-flex justify-content-between">
            Machinenaam
            <span>
              <e-badge color="elegant" small>{{ app.machineName }}</e-badge>
            </span>
          </div>
        }
        <ng-container slot="actions">
          <e-edit-icon-button (click)="openEditDialog(app)"></e-edit-icon-button>
          <e-delete-icon-button (click)="deleteApp(app)"></e-delete-icon-button>
        </ng-container>
      </e-collapsible-list-item>
    }
  </div>
</e-list>

<e-dialog [(open)]="editDialogOpened" size="lg" title="App bewerken">
  <ng-template>
    <formly-metadata-form
      (cancel)="closeEditDialog()"
      (save)="updateApp($event)"
      [loading]="isUpdating"
      [model]="appToEdit"
      key="edit"
    ></formly-metadata-form>
  </ng-template>
</e-dialog>

<e-dialog [(open)]="createDialogOpened" size="lg" title="Nieuwe app">
  <ng-template>
    <formly-metadata-form
      (cancel)="closeCreateDialog()"
      (save)="createApp($event)"
      [loading]="isCreating"
      [model]="newApp"
      key="create"
    ></formly-metadata-form>
  </ng-template>
</e-dialog>
